<template>
  <el-dialog :visible.sync="dialogVisible" :show-close="false"
    @close="dialogClose">
    <img
      class="close-img"
      src="@/assets/img/images/icon/close-icon.png"
      @click="dialogVisible = false"
    />

    <template v-if="step === 1">
      <p class="p1">{{ $t("user_center.account_safe.google.title") }}</p>
      <p class="p2 mt20">1.{{ $t("google_bind.download_title") }}</p>
      <p class="p3 mt12">
        {{ $t("google_bind.download_desc") }}
      </p>
      <div class="c-flex mt20">
        <div class="box-icon1">
          <img class="icon-ios1" src="@/assets/img/images/icon/ios-icon.png" />
          App Store
        </div>
        <div class="box-icon2 ml20">
          <!-- <img class="icon-ios1" src="@/assets/img/images/icon/ios-icon.png" />
        Google Play -->
        </div>
      </div>
      <p class="p2 mt20">2.{{ $t("google_bind.add_title") }}</p>
      <p class="p3 mt12">
        {{ $t("google_bind.add_desc") }}
      </p>
      <div class="c-flex mt20">
        <!-- <img class="icon-qr" src="@/assets/img/images/qr-code-black.png" /> -->
        <qriously
          class="icon-qr"
          :value="googleQRCode.otpauth"
          :size="160"
          :padding="0"
        />
        <div class="ml40 c-flex-space-center c-flex-column">
          <p class="p4">{{ googleQRCode.googleAuthenticator }}</p>
          <p
            class="p5 mt12"
            @click="copyToClipboard(googleQRCode.googleAuthenticator)"
          >
            {{ $t("google_bind.copy_key") }}
          </p>
        </div>
      </div>
      <p class="p2 mt40">3.{{ $t("google_bind.success_tip") }}</p>
      <p class="p3 mt12">
        {{ $t("google_bind.success_tip2") }}
      </p>
      <el-form class="mt20">
        <el-form-item :label="$t('google_bind.input_code')" prop="password">
          <el-input
            v-model="googleCode"
            :placeholder="$t('tipsVal.inputPlaceholder')"
          />
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <div class="btn2" @click="nextStep">{{ $t("google_bind.next") }}</div>
      </div>
    </template>
    <template v-if="step === 2">
      <el-form :model="googleBind" :rules="rules" ref="ruleForm">
        <el-form-item
          v-if="user.phoneSecurity === 1"
          :label="$t('google_bind.phone_code')"
          prop="phoneCode"
        >
          <el-input
            v-model="googleBind.phoneCode"
            :placeholder="$t('tipsVal.inputPlaceholder')"
          >
            <template slot="append">
              <span v-if="!phoneCodeStatus.hasSend" @click="hasSendPhoneCode">
                {{ $t("google_bind.get_code") }}</span
              >
              <span v-else>{{ phoneCodeStatus.times }}</span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item
          v-if="user.emailSecurity === 1"
          :label="$t('google_bind.email_code')"
          prop="emailCode"
        >
          <el-input
            v-model="googleBind.emailCode"
            :placeholder="$t('tipsVal.inputPlaceholder')"
          >
            <template slot="append">
              <span v-if="!emailCodeStatus.hasSend" @click="hasSendEmailCode">
                {{ $t("google_bind.get_code") }}</span
              >
              <span v-else>{{ emailCodeStatus.times }}</span>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <div class="btn2" @click="submit">{{ $t("google_bind.next") }}</div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialogVisible: false,

      step: 1,
      googleQRCode: {
        googleAuthenticator: "",
        otpauth: "",
      },
      googleCode: "",
      googleBind: {
        emailCode: "",
        emailToken: "",
        googleCode: "",
        phoneCode: "",
        phoneToken: "",
        token: "",
      },
      phoneCodeSend: {
        serviceName: "bindGoogle",
        verifyType: "phone",
      },
      phoneCodeStatus: {
        hasSend: false,
        times: 60,
      },
      emailCodeSend: {
        serviceName: "bindGoogle",
        verifyType: "email",
      },
      emailCodeStatus: {
        hasSend: false,
        times: 60,
      },
      rules: {
        phoneCode: [
          {
            required: true,
            message: this.$t("validate.mes_code_require"),
            trigger: "blur",
          },
        ],
        emailCode: [
          {
            required: true,
            message: this.$t("validate.email_code_require"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  created() {
    this.getQRCode();
  },
  methods: {
    getQRCode() {
      this.$axios.post("/userSecurity/generateQRCode", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.googleQRCode = res.data.data;
        }
      });
    },
    copyToClipboard(val) {
      navigator.clipboard
        .writeText(val)
        .then(() => {
          this.$message({
            type: "success",
            message: this.$t("tipsVal.copySucess"),
          });
        })
        .catch((err) => {
          this.$message({
            type: "warning",
            message: this.$t("tipsVal.copyerror"),
          });
        });
    },
    nextStep() {
      this.$axios
        .post("/userSecurity/verifyGoogleAuthenticator", {
          googleCode: this.googleCode,
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.step = 2;
            this.googleBind.token = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    hasSendPhoneCode() {
      this.phoneCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.phoneCodeStatus.times <= 0) {
          this.phoneCodeStatus.hasSend = false;
          this.phoneCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.phoneCodeStatus.times--;
        }
      }, 1000);
      this.$axios.post("/sendCode/send", this.phoneCodeSend).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.googleBind.phoneToken = res.data.data.token;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    hasSendEmailCode() {
      this.emailCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.emailCodeStatus.times <= 0) {
          this.emailCodeStatus.hasSend = false;
          this.emailCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.emailCodeStatus.times--;
        }
      }, 1000);
      this.$axios.post("/sendCode/send", this.emailCodeSend).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.googleBind.emailToken = res.data.data.token;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    submit() {
      let ref = this.$refs.ruleForm;
      ref.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.$axios
            .post("/userSecurity/bindGoogleAuthenticator", this.googleBind)
            .then((res) => {
              if (res.data.code === this.errorCode.ok) {
                this.elMessage("success", this.$t("google_bind.success"));
                this.$store.dispatch("actions_getUserInfo").then((res) => {
                  this.dialogVisible = false;
                });
              } else {
                this.elMessage("error", res.data.msg);
              }
            });
        }
      });
    },
    dialogClose() {
      this.googleCode = ''
    },
    onCopy: function (e) {
      alert(this.$t("user_assets.copy_success"));
    },
    onError: function (e) {
      alert(this.$t("user_assets.copy_error"));
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  width: 700px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 32px 30px;
  }
  .el-form-item__label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }

  .el-input__suffix,
  .el-input__suffix-inner {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-input-group--append {
    gap: 16px;
    display: flex;
  }
  .el-input__inner {
    height: 60px;
    border-radius: 8px 8px 8px 8px;
  }
  .el-input-group__append {
    cursor: pointer;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid var(--primary-color);
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: var(--primary-color);
    padding: 0 24px;
    width: auto;
    display: flex;
    align-items: center;
  }
  .el-form-item {
    margin-bottom: 0;
  }
}
.mt8 {
  margin-top: 8px;
}
.p1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 36px;
  color: #333333;
}
.p2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
}
.p3 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #999999;
}
.p4 {
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 24px;
  color: #333333;
}
.p5 {
  cursor: pointer;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: var(--primary-color);
}
.close-img {
  width: 14px;
  height: 14px;
  top: 20px;
  right: 20px;
  cursor: pointer;
  position: absolute;
}
.icon-ios1 {
  width: 26px;
  height: 26px;
}
.icon-qr {
  width: 120px;
  height: 120px;
}
.box-icon1 {
  gap: 8px;
  width: 160px;
  height: 48px;
  display: flex;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  align-items: center;
  background: var(--primary-color);
  justify-content: center;
  border-radius: 6px 6px 6px 6px;
}
.box-icon2 {
  gap: 8px;
  width: 160px;
  height: 48px;
  display: flex;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
  align-items: center;
  background: #000000;
  justify-content: center;
  border-radius: 6px 6px 6px 6px;
  background-size: 100%;
  background-image: url(~@/assets/img/images/btn-bj.png);
}
.btn-box {
  gap: 10px;
  display: flex;
  margin-top: 32px;
  .btn1 {
    flex: 1;
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid var(--primary-color);
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: var(--primary-color);
  }
  .btn2 {
    flex: 1;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    background: var(--primary-color);
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: var(--white-color);
  }
}
</style>
